import React, { createRef } from "react";
import LayoutBasic from "../layouts/layoutBasic";
import { Helmet } from "react-helmet";
import { GET_USER_URL, TOKEN } from "../vars";
import { getLocalKeyValue } from "../storage";
import { withRouter } from "next/router";
import { SeoMetaAIFaceSync } from '../components/seoMeta'
import checkIsOutsideIndia from '../components/checkIsOutsideIndia'
import axios from "axios";
import LicenseNotice from "../components/LicenseNotice";

class ai_face_sync extends React.Component {
    constructor(props) {
        super();
        this.state = {
            eventType: "",
            eventDate: "",
            details: "",
            errors: {},
            successMessage: '',
            errorMessage: '',
            latitude: null,
            longitude: null,
            isOutsideIndia: false,
            basePrice: null,       // Store calculated base price
            baseCrossPrice: null,  // Store calculated cross price for base package
            oneMonthExtra: null,   // Store calculated price for extra 1 month
            threeMonthExtra: null, // Store calculated price for extra 3 months
        };
        this.videoRef = createRef();
        this.handleBookNow = this.handleBookNow.bind(this);
    }



    static async getInitialProps(props) {
        let token = (await process.browser)
            ? getLocalKeyValue(TOKEN)
            : props.query.sec_token;
        let infoRequest,
            infoResponse = {};

        if (token) {
            try {
                infoRequest = await GET(GET_USER_URL, token);
                infoResponse = await infoRequest.data;
            } catch (e) { }
        }

        return {
            token: token,
            user: infoResponse.user,
            cart: infoResponse.cart,
            // pagination: {
            //     page: data.page,
            //     total_pages: data.total_pages
            // },
        };
    }

    playPause = () => {
        const video = this.videoRef.current;
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleBlur = (e) => {
        this.setState({
            errors: {
                ...this.state.errors,
                [e.target.name]: '', // Clear specific field error on blur
            },
        });
    };

    // Function to get the currency symbol based on location
    // const getCurrencySymbol = () => isOutsideIndia ? '$' : '₹';
    // const calculatePrice = (basePrice, outsideIndiaMultiplier) =>
    //     this.state.isOutsideIndia ? (basePrice * outsideIndiaMultiplier).toFixed(1) : basePrice;

    /*calculatePrice(basePrice, extraMonths) {
        let price = basePrice; // Base price is 499

        if (this.state.isOutsideIndia) {
            price = price / 61; // Convert INR to USD assuming 1 USD = 61 INR
            if (extraMonths === 1) price = 6.5; // Override for 1 month extra
            else if (extraMonths === 3) price = 16.3; // Override for 3 months extra
        } else {
            if (extraMonths === 1) price = 399; // Override for 1 month extra in INR
            else if (extraMonths === 3) price = 999; // Override for 3 months extra in INR
        }

        return price.toFixed(1); // Rounding to one decimal place for display
    }*/

    calculatePrice(basePrice, crossBasePrice, extraMonths) {
        let price = basePrice; // Base price is typically 499
        let crossPrice = crossBasePrice; // Cross price for comparison (e.g., 599)

        if (this.state.isOutsideIndia) {
            price = price / 61; // Convert INR to USD assuming 1 USD = 61 INR
            if (crossPrice !== null) crossPrice = crossPrice / 61; // Convert cross price if provided
            if (extraMonths === 1) {
                price = 6.5; // Override for 1 month extra
                crossPrice = null; // No cross price for add-ons
            } else if (extraMonths === 3) {
                price = 16.3; // Override for 3 months extra
                crossPrice = null; // No cross price for add-ons
            }
        } else {
            if (extraMonths === 1) {
                price = 399; // Override for 1 month extra in INR
                crossPrice = null; // No cross price for add-ons
            } else if (extraMonths === 3) {
                price = 999; // Override for 3 months extra in INR
                crossPrice = null; // No cross price for add-ons
            }
        }

        return {
            price: (this.state.isOutsideIndia) ? price.toFixed(1) : price,
            crossPrice: crossPrice !== null ? (this.state.isOutsideIndia) ? crossPrice.toFixed(1) : crossPrice : null
        };
    }

    async componentDidMount() {

        const { latitude, longitude } = this.props;
        await this.getGeolocationByIP();  // Only use IP-based geolocation

        this.updatePriceCalculations();

        //const isOutsideIndia = checkIsOutsideIndia(latitude, longitude);
        //this.setState({ isOutsideIndia })

        if (latitude !== null && longitude !== null) {
            const isOutsideIndia = checkIsOutsideIndia(latitude, longitude);
            this.setState({ isOutsideIndia, loading: false });
        } else {
            this.setState({ error: "Could not determine location", loading: false });
        }

        // Initialize the OwlCarousel



        this.initializeOwlCarousel = () => {
            if (typeof window !== 'undefined' && typeof $ !== 'undefined') {
                $("#photgraphers-slider").owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: true,
                    autoplay: true,
                    autoplayTimeout: 3000,
                    autoplayHoverPause: true,
                    responsive: {
                        0: {
                            items: 1, // 1 item for mobile
                        },
                        600: {
                            items: 2, // You can adjust this if you want more items between mobile and desktop
                        },
                        1000: {
                            items: 4, // 4 items for desktop
                        },
                    },
                });


                // $("#photgraphers-slider").owlCarousel({
                //     loop: true,
                //     margin: 10,
                //     nav: true,
                //     autoplay: true,
                //     autoplayTimeout: 3000,
                //     autoplayHoverPause: true,
                //     responsive: {
                //         0: {
                //             items: 1
                //         },
                //         600: {
                //             items: 1
                //         },
                //         1000: {
                //             items: 4
                //         }
                //     }
                // });

            } else {

                console.error('jQuery or Owl Carousel not loaded');
            }
        };

        if (typeof window !== 'undefined') {
            // Check if Owl Carousel is available
            const script = document.createElement('script');
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/owl.carousel.min.js";
            // script.onload = initializeOwlCarousel;
            script.onload = this.initializeOwlCarousel;
            //script.onload = this.initializeOwlCarousel_2;

            document.body.appendChild(script);
        }


        this.testimonial = () => {
            if (typeof window !== 'undefined' && typeof $ !== 'undefined') {
                $("#testimonial-slider").owlCarousel({
                    items: 2,
                    pagination: false,
                    slideSpeed: 1000,
                    autoPlay: true,
                    nav: true,
                    dots: false,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 1
                        },
                        1000: {
                            items: 1
                        }
                    }
                });
            } else {

                console.error('jQuery or Owl Carousel not loaded');
            }
        };


        if (typeof window !== 'undefined') {
            // Check if Owl Carousel is available
            const script = document.createElement('script');
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/owl.carousel.min.js";
            // script.onload = initializeOwlCarousel;
            // script.onload = this.initializeOwlCarousel_2;
            script.onload = this.testimonial;

            document.body.appendChild(script);
        }


        this.Carousel2 = () => {
            if (typeof window !== 'undefined' && typeof $ !== 'undefined') {
                $("#clients-slider").owlCarousel({
                    items: 1,
                    itemsDesktop: [1000, 2],
                    itemsDesktopSmall: [990, 2],
                    itemsTablet: [768, 1],
                    pagination: true,
                    navigation: false,
                    navigationText: ["", ""],
                    slideSpeed: 1000,
                    autoPlay: true
                });
            }
        }


        if (typeof window !== 'undefined') {
            // Check if Owl Carousel is available
            const script = document.createElement('script');
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/owl.carousel.min.js";
            // script.onload = initializeOwlCarousel;
            // script.onload = this.initializeOwlCarousel_2;
            script.onload = this.Carousel2;

            document.body.appendChild(script);
        }


        // // Tab icon change logic
        // const tabs = document.querySelectorAll(".nav-link");

        // tabs.forEach((tab) => {
        //     tab.addEventListener("click", function () {
        //         // Reset all images to vector.svg
        //         tabs.forEach((t) => {
        //             const icon = t.querySelector(".tab_icon");
        //             if (icon) {
        //                 icon.src = "img/Vector.svg"; // Default image
        //             }
        //         });

        //         // Set the active tab's image to object.svg
        //         const activeIcon = this.querySelector(".tab_icon");
        //         if (activeIcon) {
        //             activeIcon.src = "img/objects.svg"; // Change to the active image
        //         }
        //     });
        // });
        //         // Set the active tab's image to object.svg
        //         const activeIcon = this.querySelector(".tab_icon");
        //         if (activeIcon) {
        //             activeIcon.src = "img/cam-icon-white.svg"; // Change to the active image
        //         }
        //     });
        // });


        // Check if we are on the client-side (browser)
        if (typeof window !== 'undefined') {
            // Append Swiper CSS dynamically
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = "https://unpkg.com/swiper/swiper-bundle.min.css";
            document.head.appendChild(link);

            // Add Google Fonts link
            const googleFontsLink = document.createElement("link");
            googleFontsLink.rel = "stylesheet";
            googleFontsLink.href = "https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:ital,wght@0,300;0,400;0,500;0,700;1,300&family=Space+Mono:wght@400;700&display=swap";
            document.head.appendChild(googleFontsLink);

            // Append Swiper JS dynamically
            const script = document.createElement("script");
            script.src = "https://unpkg.com/swiper/swiper-bundle.min.js";
            script.onload = this.initializeSwiper; // Initialize Swiper after the script is loaded
            document.body.appendChild(script);
        }

        // Load Bootstrap CSS
        // const link = document.createElement("link");
        // link.rel = "stylesheet";
        // link.href =
        // "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css";
        // document.head.appendChild(link);

        // Load Bootstrap JS (for accordion functionality)
        const script = document.createElement("script");
        script.src =
            "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js";
        script.async = true;
        document.body.appendChild(script);

    }
    //geo location
    getGeolocationByIP = async () => {
        try {
            const response = await axios.get('https://ipapi.co/json/');
            const { latitude, longitude } = response.data;
            this.setState({
                latitude,
                longitude,
                error: null,
                loading: false,  // Stop loading once location is fetched
            });
        } catch (error) {
            this.setState({
                error: "Failed to retrieve geolocation by IP.",
                loading: false,  // Stop loading if there's an error
            });
        }
    }

    // Initialize Swiper after the script has been loaded
    initializeSwiper = () => {
        const progressCircle = document.querySelectorAll(".autoplay-progress svg");

        // Initialize Swiper for the thumb navigation
        var swiper = new Swiper(".tabs-thumb", {
            slidesPerView: "auto",
            direction: "horizontal",
            watchSlidesProgress: true,
            spaceBetween: 14,
            mousewheel: true,
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 2
                },
                993: {
                    direction: "vertical",
                    slidesPerView: "auto"
                }
            }
        });

        // Initialize Swiper for content
        new Swiper(".tabs-content", {
            loop: true,
            centeredSlides: true,
            loopedSlides: true,
            slidesPerView: 1,
            autoplay: {
                delay: 5000
            },
            thumbs: {
                swiper: swiper
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction"
            },
            on: {
                autoplayTimeLeft(s, time, progress) {
                    progressCircle.forEach((element) => {
                        element.style.setProperty("--progress", 1 - progress);
                    });
                }
            }
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOutsideIndia !== this.state.isOutsideIndia) {
            this.updatePriceCalculations();
        }
    }

    updatePriceCalculations = () => {
        /*const base = this.calculatePrice(499, 599, 0); // Base price with cross price
        this.setState({
            basePrice: this.calculatePrice(499, 0),
            baseCrossPrice: base.crossPrice,
            oneMonthExtra: this.calculatePrice(399, 1),
            threeMonthExtra: this.calculatePrice(999, 3)
        });*/

        const base = this.calculatePrice(499, 999, 0); // Base price with cross price
        const oneMonth = this.calculatePrice(399, null, 1); // No cross price for add-ons
        const threeMonth = this.calculatePrice(999, null, 3); // No cross price for add-ons

        this.setState({
            basePrice: base.price,
            baseCrossPrice: base.crossPrice,
            oneMonthExtra: oneMonth.price,
            threeMonthExtra: threeMonth.price
        });
    }

    /*handleBookNow = () => {
      const { basePrice, selectedAddon, isOutsideIndia } = this.state;
      let priceData = { basePrice: parseFloat(basePrice) };
      if (selectedAddon) {
          const extraPrice = selectedAddon === 'oneMonth' ? oneMonthExtra : threeMonthExtra;
          priceData.addOnPrice = parseFloat(extraPrice);
          priceData.addOnDuration = selectedAddon === 'oneMonth' ? '1 Month' : '3 Months';
      }
  
      // Assuming you're using react-router or similar for navigation
      // this.props.history.push({
      //     pathname: '/checkout',
      //     state: priceData
      // });
      // Serialize the data to URL
      const queryParams = new URLSearchParams(priceData).toString();
      window.location.href = `/ai_facesync_checkout?${queryParams}`;
  }*/

    handleBookNow = (addon = null) => {
        const { basePrice, baseCrossPrice, oneMonthExtra, threeMonthExtra, isOutsideIndia } = this.state;
        let priceData = {
            //basePrice: parseFloat(basePrice),
            plan_name: isOutsideIndia ? 'AI_FACE_SYNC_BASIC_USD' : 'AI_FACE_SYNC_BASIC_INR',
            //crossBasePrice: parseFloat(baseCrossPrice),
            //plan_name: 'ai-sync-1-month'
        };

        // if (addon) {
        //   priceData.addOnPrice = parseFloat(addon === 'oneMonth' ? oneMonthExtra : threeMonthExtra);
        //   priceData.addOnDuration = addon === 'oneMonth' ? '1 Month' : '3 Months';
        //   priceData.plan_name = addon === 'oneMonth' ? 'ai-sync-extra-1-month' : 'ai-sync-extra-3-month';
        // }

        const queryParams = new URLSearchParams(priceData).toString();
        window.location.href = `/ai_facesync_checkout?${queryParams}`;
    };

    render() {
        const { errors, isOutsideIndia, basePrice, baseCrossPrice, oneMonthExtra, threeMonthExtra } = this.state;
        const currencySymbol = isOutsideIndia ? '$' : '₹';
        //const basePrice = this.calculatePrice(499, 0);
        //const oneMonthExtra = this.calculatePrice(499, 1);
        //const threeMonthExtra = this.calculatePrice(499, 3);

        let title = "AI Face Sync | Instantly Find Every Photo You're In | Picxy";
        //console.log(this.state);
        return <LayoutBasic title={title} {...this.props} navSearchBtn={'no'} defaultNavBar={true}>

            <SeoMetaAIFaceSync router={this.props.router} title={title} description={"Upload one selfie and instantly receive every photo you're in. Perfect for corporate events, conferences, weddings, marathons, college fests, and large gatherings."} image={"https://dev.picxy.com/static/imgv1/ai-face-sync.webp"} />
            <LicenseNotice />

            <>

                <Helmet>
                    <title>AI Face Sync | Instantly Find Every Photo You're In | Picxy</title>
                    <meta
                        property="og:title"
                        content="Never Search for Your Event Photos Again"
                    />
                    <meta
                        property="og:description"
                        content="Upload one selfie and instantly receive every photo you're in. A seamless guest experience for every event."
                    />
                    <meta
                        property="og:image"
                        content="https://dev.picxy.com/static/imgv1/ai-face-sync.webp"
                    />
                </Helmet>

                {/* <!-- Banner-ai section Starts--> */}
                <section className="banner-ai">
                    <div className="banner-opacity">
                        <div className="container">
                            <h2 className="heading">Smart <span className="accent-word">AI-Face</span> Sync</h2>
                            <p className="para"> Capture every smile on your special day with our AI-Face Sync. No more chaos of endlessly searching for guest photos and sharing them. Our tool recognizes every face ensuring no moment is missed which lasted for years</p>
                            <div className="position-relative ai-face-sync-img">
                                <img src="../static/img/facesync/image_slider.png" style={{ width: '100%' }} />

                            </div>

                            <div className="opt1-wrap">
                                <button className="opt1-btn" id="btn1" onClick={() => window.open("https://api.whatsapp.com/send?phone=918885558235&text=Hello%2C%20Picxy%21%20Interested%20in%20AI%20face-sync%20for%20a%20event", "_blank")}>
                                    <span className="ico">✦</span> Connect With Us <span className="ico">✦</span>
                                </button>
                                <div className="opt1-hint">Not sure where to start? We'll walk you through it.</div>
                            </div>


                        </div>
                    </div>
                    <div class="hero-bg"></div>
                    <div class="hero-grid"></div>
                </section>
                {/* <!-- Banner-ai section Ends --> */}

                {/* <!-- Video-ai section starts--> */}
                <section className="video-ai">
                    <div>
                        <img
                            className="righttop"
                            src="../static/img/facesync/dots.png"
                            alt="Dots"
                        />
                        {/* <div className="show">
                    <video
                    ref={this.videoRef}
                    muted
                    poster="../static/img/facesync/thumbnail.png"
                    onClick={this.playPause}
                    >
                    <source
                        //src="https://player.vimeo.com/external/194837908.sd.mp4?s=c350076905b78c67f74d7ee39fdb4fef01d12420&profile_id=164"
                        src="https://www.youtube.com/embed/JSyxiFR1Ffs"
                        type="video/mp4"
                    />
                    </video>
                    {/* Custom video control icon /*
                    <div className="video-control" onClick={this.playPause}>
                    {/* <i className="fa-solid fa-circle-play fa-3x"></i>
                    </div>
                </div> */}
                        <div className="show text-center">
                            <div className="video-bg">
                                <iframe
                                    width="660"
                                    height="315"
                                    src="https://www.youtube.com/embed/L2ujxYRXE6I?si=g7xq8GJbf5ISncU7"
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                        <h3>Explore the magic of <strong>AI-Face Sync</strong> Galleries</h3>
                        <img
                            className="bottomleft"
                            src="../static/img/facesync/dots.png"
                            alt="Dots"
                        />
                    </div>
                </section>
                {/* <!-- Video-ai section ends--> */}
                {/* <!-- why picxy Section Starts here --> */}
                {/* <section className="whypicxy">
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="sub_heading">Smart AI Face- Sync</h2>
                                <p className="sub_text">
                                Capture every smile on your special day with out AI Face Sync. No more chaos of endlessly searching for guest photos

                                and sharing them. Our tool recognizes every face, ensuring no moment in missed, which lasted for years.

                                </p>
                            </div>
                        </div>

                        <div className="row badgetrow mt-5">
                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">1</p>
                                <img src="../static/img/Vector.svg" alt="Access to photographers" className="img-fluid pb-3" />
                                <h6 className="badgettext">Access to 2+ million photographers</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">2</p>
                                <img src="../static/img/Vector.svg" alt="Expertise in events" className="img-fluid pb-3" />
                                <h6 className="badgettext">Expertise across various event types</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">3</p>
                                <img src="../static/img/Vector.svg" alt="Affordable photography" className="img-fluid pb-3" />
                                <h6 className="badgettext">Affordable, professional photography</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">4</p>
                                <img src="../static/img/Vector.svg" alt="High-quality delivery" className="img-fluid pb-3" />
                                <h6 className="badgettext">High-quality delivery, customized to your needs</h6>
                            </div>
                        </div>
                    </div>
                </section>  */}
                {/* <!--- Grid Starts----> */}
                <section className="tabs-ai">
                    <div className="container">
                        <h2 className="heading">How it Works</h2>
                        <div className="tabs-wrapper">
                            <div className="swiper tabs-content">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide">
                                        <div className="tabs-slide-content">
                                            <img src="../static/img/facesync/ai_face_1.png" style={{ width: '90%' }} className="img-fluid" />
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="tabs-slide-content">
                                            <img src="../static/img/facesync/ai_face_2.png" style={{ width: '90%' }} className="img-fluid" />
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="tabs-slide-content">
                                            <img src="../static/img/facesync/ai_face_3.png" style={{ width: '60%' }} className="img-fluid" />
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="tabs-slide-content">
                                            <img src="../static/img/facesync/ai_face_4.png" style={{ width: '45%' }} className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="swiper tabs-thumb">
                                <div className="swiper-wrapper tabs-thumb-wrapper">
                                    <button className="swiper-slide">
                                        <div className="tabs-thumb-header">
                                            <div className="tabs-thumb-avatar">
                                                <img src="../static/img/facesync/icon1.png" />
                                                <div className="autoplay-progress">

                                                </div>
                                            </div>
                                            <div className="tabs-thumb-details">
                                                <h3>Create Event & Invite</h3>
                                                <p>Create & Share the event QR Code seamlessly via email, or WhatsApp.</p>
                                            </div>
                                        </div>
                                    </button>
                                    <button className="swiper-slide">
                                        <div className="tabs-thumb-header">
                                            <div className="tabs-thumb-avatar">
                                                <img src="../static/img/facesync/icon2.png" />
                                                <div className="autoplay-progress">

                                                </div>
                                            </div>
                                            <div className="tabs-thumb-details">
                                                <h3>Selfie with QR Code</h3>
                                                <p>Let attendees scan the QR code and capture their selfie to be part of the event photos</p>
                                            </div>
                                        </div>
                                    </button>
                                    <button className="swiper-slide">
                                        <div className="tabs-thumb-header">
                                            <div className="tabs-thumb-avatar">
                                                <img src="../static/img/facesync/icon3.png" />
                                                <div className="autoplay-progress">

                                                </div>
                                            </div>
                                            <div className="tabs-thumb-details">
                                                <h3>Spot-On Recognition</h3>
                                                <p>Picxy AI-Face Sync identifies 99% accuracy, displaying all their photos instantly.</p>
                                            </div>
                                        </div>
                                    </button>
                                    <button className="swiper-slide">
                                        <div className="tabs-thumb-header">
                                            <div className="tabs-thumb-avatar">
                                                <img src="../static/img/facesync/icon4.png" />
                                                <div className="autoplay-progress">

                                                </div>
                                            </div>
                                            <div className="tabs-thumb-details">
                                                <h3>Personalized Gallery</h3>
                                                <p>Your images are just a tap away - view or download them from your mobile.</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                                <div className="swiper-scrollbar"></div>
                            </div>

                        </div>

                        <div className="banner-strip" id="bannerStrip">
                            <div className="banner-text">
                                <strong>Not sure which step to take next?</strong><br />
                                <span>Our team will guide you through the entire AI-Face Sync journey.</span>
                            </div>
                            <div className="banner-actions">
                                <button className="banner-btn" id="btn4" onClick={() => window.open("https://api.whatsapp.com/send?phone=918885558235&text=Hello%2C%20Picxy%21%20Interested%20in%20AI%20face-sync%20for%20a%20event", "_blank")}>✦ Get Assistance ✦</button>
                            </div>
                        </div>

                    </div>
                </section>
                {/* <!--- Grid Ends---->  */}
                {/* Banner Section Ends here */}

                {/* Additional sections go here */}
                {/* <!-- Tag section for desktop view --> */}
                {/* <div className="tag d-none d-md-block d-lg-block p-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 px-4">
                                <p className="m-3">Affordable Pricing | Our packages start from just <span className="fixed-pricing">INR 3000/-</span></p>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <!-- Tag Section Ends here --> */}

                {/* <!-- AI Face Sync Section Starts here --> */}
                {/*<section className="aifacesync">
                <div className="container my-5">
                <div className="row">
                    <div className="col-sm-6">
                    {/* <div className="border rounded p-2 p-md-5">
                        Please e-mail any queries/issues to&nbsp;
                        <a href="mailto:support@picxy.com">support@picxy.com</a>&nbsp;
                        or contact us at : +91 8885558235
                    </div>
                    </div>
                    <div className="col-sm-6 ">
                    <div className="contactus mt-4 mt-md-0 pl-md-5">
                        <div className="row">
                            <div className="col-12" >
                                <h2 className="sub_heading">AI Face-Sync</h2>
                                <p className="sub_text">
                                Capturing Personalized Moments for your Guests with Advanced Face Recognition Technology.
                                </p>
                                <div className="col-4 ml-5" >
                                    <button
                                        type="submit"
                                        id="submit"
                                        className="btn btn-primary btn-block p-3"
                                    >
                                        Read More </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                    {/* <div className="container py-5">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="sub_heading">AI Face-Sync</h2>
                                <p className="sub_text">
                                Capturing Personalized Moments for your Guests with Advanced Face Recognition Technology.

                                </p>
                            </div>
                        </div>

                        <div className="row badgetrow mt-5">
                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">1</p>
                                <img src="../static/img/Vector.svg" alt="Access to photographers" className="img-fluid pb-3" />
                                <h6 className="badgettext">Access to 2+ million photographers</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">2</p>
                                <img src="../static/img/Vector.svg" alt="Expertise in events" className="img-fluid pb-3" />
                                <h6 className="badgettext">Expertise across various event types</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">3</p>
                                <img src="../static/img/Vector.svg" alt="Affordable photography" className="img-fluid pb-3" />
                                <h6 className="badgettext">Affordable, professional photography</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">4</p>
                                <img src="../static/img/Vector.svg" alt="High-quality delivery" className="img-fluid pb-3" />
                                <h6 className="badgettext">High-quality delivery, customized to your needs</h6>
                            </div>
                        </div>
                    </div>
                </section> */}
                {/* <!-- AI Face Sync Section Ends here --> */}

                {/* <!-- pricing section Starts here --> */}
                {/*<section className="pricing-ai">
                    <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-xl-2 d-none d-xl-block">
                        <img src="../static/img/facesync/scan.png" alt="Scan" />
                        </div>
                        <div className="col-xl-8 col-lg-12 text">
                        <h3 className="heading">Add <b>AI-Face Sync</b> to your events</h3>
                        <div className="row">
                            <div className="col-lg-4 col-sm-12">
                            <p className="month">1 Month Validity</p>
                            <h5 className="date">{currencySymbol}{basePrice}
                            <span style={{fontSize: '23px', textDecoration: 'line-through', marginLeft:'4px'}}>
                                {currencySymbol}{baseCrossPrice}
                            </span>
                            </h5>
                            <p className="gst">{isOutsideIndia ? 'per event' : 'per event + GST'}</p>
                            </div>
                            <div className="col-lg-8 col-sm-12">
                            <div className="row box">
                                <h6>Add on Packages</h6>
                                <div className="col-lg-6 col-sm-12">
                                <p className="month">Extra 1 Month</p>
                                <h5>{currencySymbol}{oneMonthExtra}</h5>
                                <p className="gst">{isOutsideIndia ? 'per event' : 'per event + GST'}</p>
                                </div>
                                <div className="col-lg-6 col-sm-12">
                                <p className="month">Extra 3 Month</p>
                                <h5>{currencySymbol}{threeMonthExtra}</h5>
                                <p className="gst">{isOutsideIndia ? 'per event' : 'per event + GST'}</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="col-xl-2 d-none d-xl-block">
                        <img src="../static/img/facesync/scan.png" alt="Scan" />
                        </div>
                    </div>
                    </div>
                    <div className="row btnsale">
                    <div className="col-lg-12 col-sm-12">
                        {/* <button className="pricing-btn px-5" onClick={() => window.open("https://api.whatsapp.com/send?phone=918885558235", "_blank")}>Book Now</button> }
                        <button className="pricing-btn px-5" onClick={this.handleBookNow}>Book Now</button>
                    </div>
                    </div>
                </section>*/}
                {/* <!-- pricing section Ends here --> */}
                {/* <!-- pricing section Starts here --> */}
                <section className="pricing-ai">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-xl-2 d-none d-xl-block">
                                <img src="../static/img/facesync/scan.png" alt="Scan" />
                            </div>
                            <div className="col-xl-8 col-lg-12 text">
                                <h3 className="heading">Add <b>AI-Face Sync</b> to your events</h3>
                                <div className="row">
                                    <h6 className="fs-5 lh-3">Bring innovation to your events with AI-Face Sync, ensuring secure and seamless identity verification. Get in touch for customized plans today!</h6>
                                </div>
                            </div>
                            <div className="col-xl-2 d-none d-xl-block">
                                <img src="../static/img/facesync/scan.png" alt="Scan" />
                            </div>
                        </div>
                    </div>
                    <div className="row btnsale">
                        <div className="col-lg-12 col-sm-12">
                            <button className="pricing-btn px-5" onClick={() => window.open("https://api.whatsapp.com/send?phone=918885558235&text=Hello%2C%20Picxy%21%20Interested%20in%20AI%20face-sync%20for%20a%20event", "_blank")}>Talk To Experts</button>
                        </div>
                    </div>
                </section>
                {/* <!-- pricing section Ends here --> */}


                <section className="faq-section">
                    <div className="container">
                        <h2 className="text-center mb-5 main-headding">Frequently Asked Questions</h2>
                        <div className="accordion mt-3" id="faqAccordion">
                            {/* Accordion Item 1 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOne">
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        How can I get the AI Face Sync feature for free?
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        Book a photographer through Picxy, and you’ll get the AI Face Sync feature at no extra cost.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 2 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTwo">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        How will I receive my photos?
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        You’ll get a smart link via Whatsapp and email to view and download your photos, just like in your gallery.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 3 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThree">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    >
                                        How accurate is face recognition?
                                    </button>
                                </h2>
                                <div
                                    id="collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        Our AI is 99.6% accurate, even in low light and different angles.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 4 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFour">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour"
                                        aria-expanded="false"
                                        aria-controls="collapseFour"
                                    >
                                        Is there a limit on attendee registrations for an event?
                                    </button>
                                </h2>
                                <div
                                    id="collapseFour"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFour"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        No limit, you can share QR code with your event participants & can allow everyone to register through that code.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 5 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFive">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFive"
                                        aria-expanded="false"
                                        aria-controls="collapseFive"
                                    >
                                        How does AI Face Sync help?
                                    </button>
                                </h2>
                                <div
                                    id="collapseFive"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFive"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        Our Deep Tech powered image recognition service detects registered attendee faces and extracts the matching photos as a collection and instantly sends such custom photo collections to individuals on registered contact details.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 6 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading6">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse6"
                                        aria-expanded="false"
                                        aria-controls="collapse6"
                                    >
                                        What if multiple cameras are used in the event?
                                    </button>
                                </h2>
                                <div
                                    id="collapse6"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading6"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        You can upload photos from all cameras consolidated under the same event link and AI-Face Sync takes care of grouping matching photos and notifies your audience.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 7 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading7">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse7"
                                        aria-expanded="false"
                                        aria-controls="collapse7"
                                    >
                                        Is my data secure?
                                    </button>
                                </h2>
                                <div
                                    id="collapse7"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading7"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        Yes, only users with the link can access event photos. Your data is private and never shared.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 8 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading8">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse8"
                                        aria-expanded="false"
                                        aria-controls="collapse8"
                                    >
                                        How many photos can be uploaded?
                                    </button>
                                </h2>
                                <div
                                    id="collapse8"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading8"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        You will get access to 5GB storage per event.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 9 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading9">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse9"
                                        aria-expanded="false"
                                        aria-controls="collapse9"
                                    >
                                        Will there be additional charges for Whatsapp notifications?
                                    </button>
                                </h2>
                                <div
                                    id="collapse9"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading9"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        No, notifications are included at no extra cost.
                                    </div>
                                </div>
                            </div>

                            {/* Accordion Item 10 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading10">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse10"
                                        aria-expanded="false"
                                        aria-controls="collapse10"
                                    >
                                        What is the pricing and validity period?
                                    </button>
                                </h2>
                                <div
                                    id="collapse10"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading10"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        The standard charge is ₹499 per event. An extra month costs ₹399, and 3 months cost ₹999.
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* <!-- collection Section Ends here --> */}
                <section className="image-ai">
                    <div className="container">
                        <h3>Celebrate Every Moment with Perfectly Captured Memories.</h3>
                        <h6>AI FaceSync creates a personalized gallery with every snapshot adding to the story of your celebration.</h6>
                        <div className="row">
                            <div className="col-lg-5 col-sm-6 divimage">
                                <img src="../static/img/facesync/img1.png" style={{ width: '516px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Weddings</p>
                            </div>
                            <div className=" col-lg-4 col-sm-6 divimage">
                                <img src="../static/img/facesync/img2.png" style={{ width: '407px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Birthdays</p>
                            </div>
                            <div className="col-lg-3 col-sm-6 divimage">
                                <img src="../static/img/facesync/img3.png" style={{ width: '298px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Sports</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-sm-6 divimage">
                                <img src="../static/img/facesync/img4.png" style={{ width: '298px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Events</p>
                            </div>
                            <div className="col-lg-3 col-sm-6 divimage">
                                <img src="../static/img/facesync/img5.png" style={{ width: '298px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Corporate</p>
                            </div>
                            <div className="col-lg-3 col-sm-6 divimage">
                                <img src="../static/img/facesync/img6.png" style={{ width: '298px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Business</p>
                            </div>
                            <div className="col-lg-3 col-sm-6 divimage">
                                <img src="../static/img/facesync/img7.png" style={{ width: '303px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Education</p>
                            </div>
                        </div>
                        <div className="row d-none">
                            <div className="col-lg-3 col-sm-6 divimage">
                                <img src="../static/img/facesync/img7.png" style={{ width: '298px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Education</p>
                            </div>
                            <div className="col-lg-4 col-sm-6 divimage">
                                <img src="../static/img/facesync/img8.png" style={{ width: '407px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Corporate</p>
                            </div>
                            <div className="col-lg-5 col-sm-6 divimage">
                                <img src="../static/img/facesync/img9.png" style={{ width: '516px' }} className="w-100 shadow-1-strong rounded mb-4 head" />
                                <p>Weddings</p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* <!-- Collection Section Starts here --> */}
                {/* <section className="collection">
                    <div className="container py-5">
                        <div className="row mb-5">
                            <div className="col-12">
                                <h2 className="sub_heading">Celebrate Every Moment with Perfectly</h2>
                                <h2 className="sub_heading">Captured Memories.</h2>
                                <p className="sub_text">
                                    AI FaceSync creates a personalized gallery with every snapshot adding to the story of your celebration.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-md-12 col-sm-12 collection1">
                                <div className="subdiv_photo">
                                    <img src="../static/img/events.png"
                                        className="w-100 shadow-1-strong rounded imagesize1"
                                        alt="Events Photography - Capture special moments" />
                                    <p className="category px-3">Events Photography<span className="category_icon">&#8594;</span></p>
                                </div>
                                <div className="subdiv_photo">
                                    <img src="../static/img/corporate.png"
                                        className="w-100 shadow-1-strong rounded imagesize2"
                                        alt="Corporate Photography - Professional business shoots" />
                                    <p className="category px-3">Corporate Photography<span className="category_icon">&#8594;</span></p>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-12 col-sm-12 pt-3 collection2">
                                {/* <h2 className="headh3 p-4 mb-4 text-center">A Collection Of Our Photoshoot Moments</h2>
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="subdiv_photo">
                                            <img src="../static/img/ads.png"
                                                className="w-100 shadow-1-strong rounded imagesize3"
                                                alt="Ads Shoot - Creative advertising photography" />
                                            <p className="category px-3">Ads Shoot<span className="category_icon">&#8594;</span></p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="subdiv_photo">
                                            <img src="../static/img/business.png"
                                                className="w-100 shadow-1-strong rounded imagesize3"
                                                alt="Business Meetings Shoot - Capturing key moments" />
                                            <p className="category px-3">Business Meetings Shoot<span className="category_icon">&#8594;</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="subdiv_photo">
                                            <img src="../static/img/wedding.png"
                                                className="w-100 shadow-1-strong rounded imagesize4"
                                                alt="Wedding Photography - Timeless memories of your special day" />
                                            <p className="category px-3">Wedding Photography<span className="category_icon">&#8594;</span></p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="subdiv_photo">
                                            <img src="../static/img/sports.png"
                                                className="w-100 shadow-1-strong rounded imagesize4"
                                                alt="Sports Photography - Dynamic action shots" />
                                            <p className="category px-3">Sports Photography<span className="category_icon">&#8594;</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-12 col-sm-12 collection3">
                                <div className="subdiv_photo">
                                    <img src="../static/img/concept.png"
                                        className="w-100 shadow-1-strong rounded imagesize1"
                                        alt="Concept Photography - Innovative and creative concepts" />
                                    <p className="category px-3">Concept Photography<span className="category_icon">&#8594;</span></p>
                                </div>
                                <div className="subdiv_photo">
                                    <img src="../static/img/kids.png"
                                        className="w-100 shadow-1-strong rounded imagesize2"
                                        alt="Kids Photography - Capturing the joy of childhood" />
                                    <p className="category px-3">Kids Photography<span className="category_icon">&#8594;</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
                {/* <!-- Collection Section Ends here --> */}

                <section className="container-fluid py-60 testimonials">
                    <div className="bg-column"></div>
                    <div className="row position-relative z-1">
                        <div className="col-xl-6 col-md-6 col-sm-12 test1 sectpad1 testimonial-content-block inner-testimonial">
                            <img src="../static/img_new/dots.png" className="dots" />
                            <h3 className="test1h3">
                                People who believed in us
                            </h3>
                            <p className="test1p">
                                Thank you for being a part of our journey .Grateful for your support and encouragement
                            </p>
                            {/* <button
                                className="custom-btn"
                                onClick={() => window.open("https://upload.picxy.com/login/", "_blank")}
                            >
                                Upload on Picxy
                            </button> */}
                        </div>
                        <div className="test1 car col-xl-6 col-md-6 col-sm-12">
                            <div id="testimonial-slider" className="owl-carousel">
                                {/* {testimonials.map((testimonial, index) => ( */}
                                <div className="testimonial-card">
                                    <img src="../static/img_new/quote.svg" style={{ width: '40px', height: '40px' }} />
                                    <p className="description">
                                        Picxy made our event experience truly memorable. The delegates loved how quickly and effortlessly they received their personalized photos, which added a unique touch to the event. The entire process was smooth, and the feedback from attendees was overwhelmingly positive
                                    </p>
                                    <div className="d-flex align-items-center">
                                        <div className='me-2'>
                                            <img src="../static/img/photgraphers/KMC.jpg" className="user" />
                                        </div>
                                        <div>
                                            <h3 className="name">Shradha Shetty</h3>
                                            <p className="designation">Faculty Coordinator, KMC college</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="testimonial-card">
                                    <img src="../static/img_new/quote.svg" style={{ width: '40px', height: '40px' }} />
                                    <p className="description">
                                        At large business conferences, attendees rarely have time to engage with additional event features. However, when we introduced AI Face Sync at our own event, the impact was immediate. Delegates loved the convenience of instantly accessing their personalized photos, making the photo-sharing process effortless
                                    </p>
                                    <div className="d-flex align-items-center">
                                        <div className='me-2'>
                                            <img src="../static/img/photgraphers/araku.jpg" className="user" />
                                        </div>

                                        <div>
                                            <h3 className="name">Ram Kumar Varma</h3>
                                            <p className="designation">Founder of Native Araku Coffee</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="testimonial-card">
                                    <img src="../static/img_new/quote.svg" style={{ width: '40px', height: '40px' }} />

                                    <p className="description">
                                        We had a great experience working with Picxy. The team was professional, responsive, & ensured everything ran seamlessly throughout the event. The AI Face Sync feature was a standout, making it effortless for delegates to instantly access their personalized event photos.
                                    </p>

                                    <div className="d-flex align-items-center">
                                        <div className='me-2'>
                                            <img src="../static/img/photgraphers/KMC.jpg" className="user" />
                                        </div>
                                        <div>
                                            <h3 className="name">Garvita</h3>
                                            <p className="designation">Student Coordinator, KMC College</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="testimonial-card">
                                    <img src="../static/img_new/quote.svg" style={{ width: '40px', height: '40px' }} />

                                    <p className="description">
                                        One of the biggest challenges after any event is finding your own photos. Usually, you have to ask friends or photographers to send them, or spend time searching through large galleries. With AI Face Sync, the process was completely effortless. I simply uploaded a selfie and instantly received all my personalized event photos.
                                    </p>

                                    <div className="d-flex align-items-center">
                                        <div className='me-2'>
                                            <img src="../static/img/photgraphers/KMC.jpg" className="user" />
                                        </div>
                                        <div>
                                            <h3 className="name">Dr. Kamakshi</h3>
                                            <p className="designation">VisionTree Eye Hospital</p>
                                        </div>
                                    </div>
                                </div>





                                {/* ))} */}
                            </div>
                        </div>
                    </div>
                </section>



                {/* <!---Client logos Starts----> */}
                {/* <section className="container clientlogo">
                    <h3 className="clientlogoh3">Our Happy Customers</h3>


                    <div className="col-12">
                        <div id="clients-slider" className="owl-carousel">
                            <div className="block-1">
                            <img src="https://images.picxy.com/clients/google-logo.png" />
                                <img src="https://images.picxy.com/clients/Ogilvy@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Thenewsminute@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Pocketaces@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Schbang@2x.jpg" />
                                <img src="https://images.picxy.com/clients/giveindia@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Manmatters@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Techstars@2x.jpg" />
                                <img src="https://images.picxy.com/clients/3one4capital@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Accel@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Thebetterindia@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Thelogicalindian@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Awaaz@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Vahak@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Vahan@2x.jpg" />
                                <img src="https://images.picxy.com/clients/The nudge@2x.jpg" />
                            </div>


                            <div className="block-1">
                            <img src="https://images.picxy.com/clients/Naandi@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Sillymonks@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Arka@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Whitenoise@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Alcrowd@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Finwego@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Tide@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Livygo@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Worknetwork@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Deepsense@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Bloggersmind@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Vasty@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Sacheerome@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Thesis@2x.jpg" />
                                <img src="https://images.picxy.com/clients/Blueowl@2x.jpg" />
                                <img src="https://images.picxy.com/clients/gobiq-logo.png" />
                            </div>


                        </div>
                    </div>


                        </section>*/}


            </>

        </LayoutBasic>

    }
}

export default withRouter(ai_face_sync);
